import { eventChestKeyIconCssClass, eventiumIconCssClass } from "@/event";
import { ResourceType } from "@/game/entities/config/resources";

export const iconClassName = (iconName: string, iconSize = 72): string => {
	if (iconName === ResourceType.EVENTIUM) {
		return eventiumIconCssClass(iconSize);
	}

	if (iconName === ResourceType.CHEST_KEY) {
		return eventChestKeyIconCssClass(iconSize);
	}
	if (iconName.toLowerCase().includes("clicker"))
		return `icon-clicker-${iconSize}`;
	if (iconName.toLowerCase().includes("skipper"))
		return `icon-adskipper-${iconSize}`;
	if (iconName === "chests") return `icon-chest-${iconSize}`;
	if (iconName.toLowerCase().includes("event_conversion_offers_rate"))
		return `icon-event-xrate-${iconSize}`;
	return `icon-${iconName.toLowerCase()}-${iconSize}`;
};
